import { styles as commonStyles } from '../../../assets/common.scss';
import { styles as styleHelpersStyles } from '../../../assets/style-helpers.scss';
import { styles } from './template.scss';
import { FontSizes, FontWeights } from '../../../types/common/types';

const accountsGridTemplate = document.createElement('template');

accountsGridTemplate.innerHTML = `
  <style>${styleHelpersStyles}</style>
  <style>${commonStyles}</style>
  <style>${styles}</style>
  <header class='page__header'>
    <gz-title fontWeight='${FontWeights.MEDIUM}' fontSize='${FontSizes.TITLE}'></gz-title>
  </header>

  <div class="wrapper">
    <div class="content">
      <div class="grid">
        <gz-grid-view class="grid-view" showGlobalActions>
            <div class="header-buttons" slot="grid-header-actions-slot">
                <gz-button id='add-account-button' class="mr-2"></gz-button>
                <gz-button id='delete-account-button' type='outline' color='negative' class="mr-2" disabled></gz-button>
            </div>
        </gz-grid-view>
      </div>

      <div id="no-results" class="hidden">
        <gz-image-repo class="mt-10" state="start">
          <gz-title fontSize='${FontSizes.HEADING_4}' id="no-results-message"></gz-title>
          <gz-text id="no-results-additional-text" fontSize="14" lineHeight="2"></gz-text>

          <gz-tooltip id="no-results-add-new-tooltip">
            <gz-button id="no-results-add-new-button" class="mt-2"></gz-button>
          </gz-tooltip>
        </gz-image-repo>
      </div>
    </div>
  </div>
`;

export default accountsGridTemplate;
